import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as OrderActions from "../actions";
import type { IOrderConfirmationReducerState } from "../types";

export type OrderAction = ActionType<typeof OrderActions>;

const initialOrderConfirmationState: IOrderConfirmationReducerState = {
  isFetching: false,
  hasError: false,
  errorStatusCode: 0,
  order: null!
};

export default function orderConfirmationReducer(
  state: IOrderConfirmationReducerState = initialOrderConfirmationState,
  action: OrderAction
): IOrderConfirmationReducerState {
  switch (action.type) {
    case getType(OrderActions.fetchOrderConfirmationStart):
      return { ...initialOrderConfirmationState, isFetching: true };

    case getType(OrderActions.fetchOrderConfirmationFail):
      return { ...state, isFetching: false, hasError: true, errorStatusCode: action.payload.statusCode || 0 };

    case getType(OrderActions.fetchOrderConfirmationSuccess):
      return { ...state, isFetching: false, order: action.payload };

    default:
      return state;
  }
}
